module.exports = __webpack_public_path__ + "img/icon_call.dca3b7bc.svg";